// import React, { useState, useEffect } from 'react';
// import {
//   Container,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Button,
//   Paper,
//   Grid,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Typography,
//   useMediaQuery,
//   useTheme,
// } from '@mui/material';
// import { styled } from '@mui/material/styles';
// import { Header } from "../Header";
// import { local_url } from '../Const';
// import { EditOrderForm } from "./EditOrderForm";
// import { useNavigate } from 'react-router-dom';



// const FixedHeader = styled('div')(({ theme }) => ({
//   position: 'fixed',
//   top: 0,
//   left: 0,
//   right: 0,
//   backgroundColor: theme.palette.background.default,
//   zIndex: 1100,
// }));




// const StyledTableCell = styled(TableCell)(({ theme }) => ({
//   width: '20%',
//   [theme.breakpoints.down('sm')]: {
//     padding: '3px',
//     fontSize: '12px',
//   },
// }));

// const StyledCustomerName = styled(Button)(({ theme }) => ({
//   fontSize: '16px',
//   padding: '6px 12px',
//   border: `1px solid ${theme.palette.primary.main}`,
//   borderRadius: '4px',
//   backgroundColor: 'transparent',
//   color: theme.palette.primary.main,
//   textTransform: 'none',
//   '&:hover': {
//     backgroundColor: theme.palette.action.hover,
//   },
//   [theme.breakpoints.down('sm')]: {
//     fontSize: '12px',
//   },
// }));

// const DateInput = styled('input')(({ theme }) => ({
//   padding: '10px',
//   marginTop: '8px',
//   border: `1px solid ${theme.palette.divider}`,
//   borderRadius: '4px',
//   '&.readonly': {
//     backgroundColor: theme.palette.action.disabledBackground,
//   },
//   [theme.breakpoints.down('sm')]: {
//     fontSize: '14px',
//   },
// }));

// const FixedTableContainer = styled(TableContainer)(({ theme }) => ({
//   maxHeight: 'calc(110vh - 300px)',
//   overflow: 'auto',
// }));

// const FixedTableHead = styled(TableHead)(({ theme }) => ({
//   position: 'sticky',
//   top: 0,
//   backgroundColor: theme.palette.background.default,
//   zIndex: 1,
//   '& th': {
//     backgroundColor: theme.palette.background.default,
//   },
// }));

// const StyledOrderIdCell = styled(StyledTableCell)(({ theme }) => ({
//   paddingLeft: '8px',
//   paddingRight: '8px',
//   fontWeight: 'bold',
//   textAlign: 'center',
//   [theme.breakpoints.down('sm')]: {
//     padding: '3px',
//     fontSize: '12px',
//   },
// }));

// export const AllotedOrders = () => {
//   const [channelId, setChannelId] = useState('web');
//   const [location, setLocation] = useState('');
//   const [areas, setAreas] = useState([]);
//   const [orders, setOrders] = useState([]);
//   const [fromDate, setFromDate] = useState(new Date());
//   const [selectedOrder, setSelectedOrder] = useState(null);
//   const [openModal, setOpenModal] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [showFullAddress, setShowFullAddress] = useState({});
//   const [branches, setBranches] = useState([]);
//   const [places, setPlaces] = useState({});
//   const [selectedPlaces, setSelectedPlaces] = useState({});
//   const [searchQuery, setSearchQuery] = useState('');
//   const [orderType, setOrderType] = useState('all'); // New state for order type filter
//   const [filteredOrders, setFilteredOrders] = useState([]); // New state for filtered orders
//   const [orderCounts, setOrderCounts] = useState({
//     deviation: 0,
//     cancellation: 0,
//     all: 0
//   });
//   const navigate = useNavigate();


//   // Add these new states
//   const [editModalOpen, setEditModalOpen] = useState(false);
//   const [selectedOrderForEdit, setSelectedOrderForEdit] = useState(null);

//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
//   const userId = localStorage.getItem('userId');
//   console.log("Retrieved userId:", userId);


//   // Add these new functions
//   const handleEditClick = (order) => {
//     setSelectedOrderForEdit(order);
//     setEditModalOpen(true);
//   };


//   const handleCancelOrder = async (orderId) => {
//     try {
//       const response = await fetch(
//         `${local_url}/api/SaleOrderList/CancelOrd/${orderId}/${userId}`,
//         {
//           method: 'POST',
//         }
//       );

//       if (response.ok) {
//         // Refresh orders after cancellation
//         const date = fromDate.toISOString().split('T')[0].replace(/-/g, '');
//         fetchOrders(date);
//       } else {
//         console.error('Failed to cancel order:', response.statusText);
//       }
//     } catch (error) {
//       console.error('Error canceling order:', error);
//     }
//   };




//   useEffect(() => {
//     const fetchAreas = async () => {
//       try {
//         const response = await fetch(`${local_url}/api/SFArea/${userId}`);
//         const data = await response.json();
//         setAreas(data);
//       } catch (error) {
//         console.error('Error fetching areas:', error);
//       }
//     };
//     console.log("------", userId);
//     fetchAreas();
//   }, []);



//   const fetchOrderCounts = async () => {
//     try {
//       const token = localStorage.getItem('AuthorizationToken'); // Fetch token from localStorage

//       if (!token) {
//         console.error('Authorization token not found');
//         return;
//       }

//       const response = await fetch(
//         'https://retailuat.abisaio.com:9001/api/OrderStatus/GetChangeRequestList/00001/ALL/20250101/20250210?FromBranchId=ALL',
//         {
//           headers: {
//             'Authorization': `Bearer ${token}`
//           }
//         }
//       );

//       if (!response.ok) {
//         throw new Error(`HTTP error! Status: ${response.status}`);
//       }

//       const data = await response.json();

//       // Count Diversion Requests (DR) and Cancellation Requests (CR)
//       let diversionCount = 0;
//       let cancellationCount = 0;

//       if (Array.isArray(data)) {
//         data.forEach(order => {
//           if (order.requestedStatus === 'DR') {
//             diversionCount++;
//           } else if (order.requestedStatus === 'CR') {
//             cancellationCount++;
//           }
//         });
//       }

//       setOrderCounts({
//         deviation: diversionCount,  // Diversion Requests count
//         cancellation: cancellationCount, // Cancellation Requests count
//         all: data.length || 0  // Total orders count
//       });

//     } catch (error) {
//       console.error('Error fetching order counts:', error);
//     }
//   };






//   const fetchOrders = async (date, orderType) => {
//     setLoading(true);
//     try {
//       // Set the base endpoint
//       let endpoint = `https://retailuat.abisaio.com:9001/api/OrderStatus/GetChangeRequestList/00001/ALL/20250101/20250201?FromBranchId=ALL`;

//       // Modify endpoint based on orderType (deviation or cancellation)
//       if (orderType === 'deviation') {
//         endpoint = `${endpoint}&requestedStatus=DR`;  // Filter for "Deviation" (DR)
//       } else if (orderType === 'cancellation') {
//         endpoint = `${endpoint}&requestedStatus=CR`;  // Filter for "Cancellation" (CR)
//       }

//       // Fetch data from the API
//       const response = await fetch(endpoint, {
//         headers: {
//           'Authorization': `Bearer ${localStorage.getItem('AuthorizationToken')}`,  // Send token for authorization
//         }
//       });

//       if (!response.ok) {
//         throw new Error(`HTTP error! Status: ${response.status}`);
//       }

//       const data = await response.json();

//       // Set the orders state based on the API response
//       setOrders(data);

//     } catch (error) {
//       console.error('Error fetching orders:', error);
//     } finally {
//       setLoading(false);
//     }
//   };



//   // Add useEffect to fetch counts when date changes
//   useEffect(() => {
//     if (channelId === 'web' && location) {
//       const date = fromDate.toISOString().split('T')[0].replace(/-/g, '');
//       fetchOrderCounts(date);
//     }
//   }, [fromDate, channelId, location]);

//   // Modify the handleOrderTypeChange function
//   const handleOrderTypeChange = (event) => {
//     setOrderType(event.target.value);
//     const date = fromDate.toISOString().split('T')[0].replace(/-/g, '');
//     fetchOrders(date);
//   };



//   const fetchBranches = async (areaId) => {
//     setLoading(true);
//     try {
//       const response = await fetch(`${local_url}/api/StoreByArea/GetStorByArea/${areaId}/LZ`);
//       const data = await response.json();
//       setBranches(data);
//     } catch (error) {
//       console.error('Error fetching branches:', error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchPlacesForPincode = async (pincode) => {
//     try {
//       const response = await fetch(`${local_url}/api/Place/${pincode}`);
//       const data = await response.json();
//       setPlaces(prevPlaces => ({
//         ...prevPlaces,
//         [pincode]: data.places || []
//       }));
//     } catch (error) {
//       console.error('Error fetching places:', error);
//     }
//   };

//   const handleChannelChange = (event) => {
//     setChannelId(event.target.value);
//     if (event.target.value === 'app') {
//       setLocation('');
//     }
//   };

//   const handleLocationChange = (event) => {
//     setLocation(event.target.value);
//     fetchBranches(event.target.value);
//   };

//   const handleAllotChange = (orderId, allottee) => {
//     setOrders((prevOrders) =>
//       prevOrders.map((order) =>
//         order.saleOrderID === orderId ? { ...order, allottedTo: allottee } : order
//       )
//     );
//   };

//   const handlePlaceChange = (orderId, placeId) => {
//     setSelectedPlaces(prev => ({
//       ...prev,
//       [orderId]: placeId
//     }));
//   };

//   const handleDateChange = (setter) => (event) => {
//     setter(new Date(event.target.value));
//   };

//   useEffect(() => {
//     if (channelId === 'web' && location) {
//       const date = fromDate.toISOString().split('T')[0].replace(/-/g, '');
//       fetchOrders(date);
//     }
//   }, [fromDate, channelId, location]);

//   const handleCustomerClick = (order) => {
//     setSelectedOrder(order);
//     setOpenModal(true);
//   };

//   const handleCloseModal = () => {
//     setOpenModal(false);
//     setSelectedOrder(null);
//   };



//   const handleSaveEdit = async (editedData) => {
//     try {
//       const response = await fetch(
//         `${local_url}/api/SaleOrderList/UpdateOrder`,
//         {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json',
//           },
//           body: JSON.stringify({
//             ...editedData,
//             updatedBy: userId
//           })
//         }
//       );

//       if (response.ok) {
//         // Refresh orders after update
//         const date = fromDate.toISOString().split('T')[0].replace(/-/g, '');
//         fetchOrders(date);
//       }
//     } catch (error) {
//       console.error('Error updating order:', error);
//     }
//   };



//   const handleSeeMoreClick = (orderId) => {
//     setShowFullAddress((prev) => ({
//       ...prev,
//       [orderId]: !prev[orderId],
//     }));
//   };

//   const handleSave = async (orderId, allottee) => {
//     try {
//       const placeId = selectedPlaces[orderId] || '';
//       const response = await fetch(
//         `${local_url}/api/SaleOrderList/RedirectDelBranch?SaleOrderId=${orderId}&ToBranchId=${allottee}&NewPlaceId=${placeId}&CreatedUserId=${userId}`,
//         {
//           method: 'POST',
//         }
//       );

//       if (response.ok) {
//         const result = await response.json();
//         console.log('Save successful:', result);
//       } else {
//         console.error('Failed to save:', response.statusText);
//       }
//     } catch (error) {
//       console.error('Error saving order:', error);
//     }
//   };

//   return (
//     <Container maxWidth="lg" sx={{ padding: isMobile ? '3px' : '8px', paddingTop: '10px' }}>
//       <FixedHeader>
//         <Header />
//       </FixedHeader>
//       <Grid container spacing={2} sx={{ marginTop: 6 }}>
//         <Grid item xs={12} sm={6} sx={{ marginTop: 2 }}>
//           <FormControl fullWidth variant="outlined">
//             <InputLabel id="channel-label">Channel ID</InputLabel>
//             <Select
//               labelId="channel-label"
//               value={channelId}
//               onChange={handleChannelChange}
//               label="Channel ID"
//             >
//               <MenuItem value="web">Web</MenuItem>
//             </Select>
//           </FormControl>
//         </Grid>
//         {channelId === 'web' && (

//           <Grid item xs={12} sm={6} spacing={2} sx={{ marginY: 2 }}>
//             <FormControl fullWidth variant="outlined">
//               <InputLabel id="location-label">Area</InputLabel>
//               <Select
//                 labelId="location-label"
//                 value={location}
//                 onChange={handleLocationChange}
//                 label="Location"
//               >
//                 {areas.map((area) => (
//                   <MenuItem key={area.sfAreaId} value={area.sfAreaId}>
//                     {area.sfAreaName}
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl>
//           </Grid>
//         )}
//       </Grid>

//       {channelId === 'web' && location && (
//         <>
//           <Grid container spacing={2} sx={{ marginBottom: 2 }}>
//             <Grid item xs={12} sm={6}>
//               <FormControl fullWidth>
//                 <InputLabel shrink htmlFor="from-date">From Date</InputLabel>
//                 <DateInput
//                   type="date"
//                   id="from-date"
//                   value={fromDate.toISOString().split('T')[0]}
//                   onChange={handleDateChange(setFromDate)}
//                 />
//               </FormControl>
//             </Grid>
//             <Grid item xs={12} sm={6}>
//               <FormControl fullWidth>
//                 <InputLabel shrink htmlFor="to-date">To Date</InputLabel>
//                 <DateInput
//                   type="date"
//                   id="to-date"
//                   value={new Date().toISOString().split('T')[0]}
//                   readOnly
//                   className="readonly"
//                 />
//               </FormControl>
//             </Grid>

//             {/* <Grid item xs={12}>
//               <Button
//                 variant="contained"
//                 color="primary"
//                 onClick={() => navigate('/create-order')}
//                 sx={{ mb: 2 }}
//               >
//                 Create Order
//               </Button>
//             </Grid> */}

//             <Grid item xs={12}>
//               <FormControl fullWidth variant="outlined">
//                 <InputLabel id="order-type-label">Order Type</InputLabel>
//                 <Select
//                   labelId="order-type-label"
//                   id="order-type-select"
//                   value={orderType}
//                   onChange={handleOrderTypeChange}
//                   label="Order Type"
//                 >
//                   <MenuItem value="all">
//                     All Orders ({orderCounts.all})
//                   </MenuItem>
//                   <MenuItem value="deviation">
//                     Request Deviation ({orderCounts.deviation})
//                   </MenuItem>
//                   <MenuItem value="cancellation">
//                     Cancellation Request ({orderCounts.cancellation})
//                   </MenuItem>
//                 </Select>
//               </FormControl>
//             </Grid>
//           </Grid>




//           <FixedTableContainer component={Paper} sx={{ marginTop: 2 }}>
//             <Table size={isMobile ? "small" : "medium"} stickyHeader>
//               <FixedTableHead>
//                 <TableRow>
//                   <StyledTableCell>Order ID</StyledTableCell>
//                   <StyledTableCell>Currently Alloted</StyledTableCell>
//                   <StyledTableCell>Allot To</StyledTableCell>
//                   <StyledTableCell>Place</StyledTableCell>
//                   <StyledTableCell>Actions</StyledTableCell>
//                   {!isMobile && <StyledTableCell>Address</StyledTableCell>}
//                 </TableRow>
//               </FixedTableHead>
//               <TableBody>
//                 {loading ? (
//                   <TableRow>
//                     <TableCell colSpan={6} align="center">
//                       <Typography>Loading orders...</Typography>
//                     </TableCell>
//                   </TableRow>
//                 ) : (
//                   orders.map((order) => {
//                     // Fetch places if not already fetched
//                     if (order.pincode && !places[order.pincode]) {
//                       fetchPlacesForPincode(order.pincode);
//                     }

//                     return (
//                       <TableRow key={order.saleOrderID}>
//                         <StyledOrderIdCell>
//                           <StyledCustomerName
//                             onClick={() => handleCustomerClick(order)}
//                             color="primary"
//                             size="small"
//                           >
//                             {order.saleOrderID}
//                           </StyledCustomerName>
//                         </StyledOrderIdCell>
//                         <StyledTableCell>
//                           <StyledOrderIdCell>
//                             {order.fromBranchID }
//                           </StyledOrderIdCell>
//                         </StyledTableCell>
//                         <StyledTableCell>
//                           <FormControl variant="outlined" size="small" fullWidth sx={{ width: '100px' }}>
//                             <InputLabel id={`allot-label-${order.saleOrderID}`}>Allot to</InputLabel>
//                             <Select
//                               labelId={`allot-label-${order.saleOrderID}`}
//                               value={order.allottedTo || ''}
//                               onChange={(e) => handleAllotChange(order.saleOrderID, e.target.value)}
//                               label="Allot to"
//                             >
//                               {branches.map((branch) => (
//                                 <MenuItem key={branch.branchID} value={branch.branchID}>
//                                   {branch.branchName}
//                                 </MenuItem>
//                               ))}
//                             </Select>
//                           </FormControl>
//                         </StyledTableCell>
//                         <StyledTableCell>
//                           <FormControl variant="outlined" size="small" fullWidth sx={{ width: '120px' }}>
//                             <InputLabel id={`place-label-${order.saleOrderID}`}>Place</InputLabel>
//                             <Select
//                               labelId={`place-label-${order.saleOrderID}`}
//                               value={selectedPlaces[order.saleOrderID] || ''}
//                               onChange={(e) => handlePlaceChange(order.saleOrderID, e.target.value)}
//                               label="Place"
//                             >
//                               {places[order.pincode]?.map((place) => (
//                                 <MenuItem key={place.placeId} value={place.placeId}>
//                                   {place.placeName}
//                                 </MenuItem>
//                               ))}
//                             </Select>
//                           </FormControl>
//                         </StyledTableCell>
//                         <StyledTableCell>
//                           <Grid container spacing={1}>
//                             <Grid item>
//                               <Button
//                                 variant="outlined"
//                                 size="small"
//                                 sx={{ minWidth: '60px' }}
//                                 onClick={() => handleSave(order.saleOrderID, order.allottedTo)}
//                                 disabled={!order.allottedTo || !selectedPlaces[order.saleOrderID]}
//                               >
//                                 Save
//                               </Button>
//                             </Grid>
//                             <Grid item>
//                               <Button
//                                 variant="outlined"
//                                 size="small"
//                                 sx={{ minWidth: '60px' }}
//                                 onClick={() => handleEditClick(order)}
//                                 color="primary"
//                               >
//                                 Edit
//                               </Button>
//                             </Grid>
//                             <Grid item>
//                               <Button
//                                 variant="outlined"
//                                 size="small"
//                                 sx={{ minWidth: '60px' }}
//                                 onClick={() => handleCancelOrder(order.saleOrderID)}
//                                 color="error"
//                               >
//                                 Cancel
//                               </Button>
//                             </Grid>
//                           </Grid>
//                         </StyledTableCell>
//                         {!isMobile && (
//                           <StyledTableCell>
//                             <Typography variant="body2">
//                               {showFullAddress[order.saleOrderID]
//                                 ? order.customerAddress
//                                 : `${order.customerAddress.substring(0, 20)}...`}
//                               <Button
//                                 size="small"
//                                 onClick={() => handleSeeMoreClick(order.saleOrderID)}
//                               >
//                                 {showFullAddress[order.saleOrderID] ? 'See Less' : 'See More'}
//                               </Button>
//                             </Typography>
//                           </StyledTableCell>
//                         )}
//                       </TableRow>
//                     );
//                   })
//                 )}
//               </TableBody>
//             </Table>
//           </FixedTableContainer>

//           <Dialog open={openModal} onClose={handleCloseModal} fullWidth maxWidth="sm">
//             <DialogTitle>Order Details</DialogTitle>
//             <DialogContent>
//               {selectedOrder && (
//                 <>
//                   <Typography variant="subtitle1">Order ID: {selectedOrder.saleOrderID}</Typography>
//                   <Typography variant="subtitle1">Customer Name: {selectedOrder.customerName}</Typography>
//                   <Typography variant="subtitle1">Current Allocated: {selectedOrder.delBranchID}</Typography>
//                   <Typography variant="subtitle1">Mobile Number: {selectedOrder.mobile}</Typography>
//                   <Typography variant="subtitle1">Delivery Schedule Date: {selectedOrder.deliveryScheduleDate}</Typography>
//                   <Typography variant="subtitle1">Time Slot: {selectedOrder.timeSlotName}</Typography>
//                   <Typography variant="subtitle1">Address: {selectedOrder.customerAddress || 'N/A'}</Typography>
//                   <Typography variant="subtitle1">Pincode: {selectedOrder.pincode || 'N/A'}</Typography>
//                   <Typography variant="subtitle1">Place: {selectedOrder.placeName || 'N/A'}</Typography>
//                   <Typography variant="subtitle1">Order Date: {new Date(selectedOrder.orderDate).toLocaleString()}</Typography>
//                   <Typography variant="subtitle1">Selected Place: {
//                     places[selectedOrder.pincode]?.find(
//                       place => place.placeId === selectedPlaces[selectedOrder.saleOrderID]
//                     )?.placeName || 'Not Selected'
//                   }</Typography>
//                 </>
//               )}
//             </DialogContent>
//             <DialogActions>
//               <Button onClick={handleCloseModal} color="primary">
//                 Close
//               </Button>
//             </DialogActions>
//           </Dialog>
//         </>
//       )}

//       {/* Add this before the closing Container tag */}
//       {selectedOrderForEdit && (
//         <EditOrderForm
//           order={selectedOrderForEdit}
//           open={editModalOpen}
//           onClose={() => {
//             setEditModalOpen(false);
//             setSelectedOrderForEdit(null);
//           }}
//           onSave={handleSaveEdit}
//           branches={branches}
//           places={places}
//         />
//       )}
//     </Container>
//   );
// };

// export default AllotedOrders;




























// import React, { useState, useEffect } from 'react';
// import {
//   Container,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Button,
//   Paper,
//   Grid,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Typography,
//   useMediaQuery,
//   useTheme,
// } from '@mui/material';
// import { styled } from '@mui/material/styles';
// import { Header } from "../Header";
// import { local_url } from '../Const';
// import { EditOrderForm } from "./EditOrderForm";
// import { useNavigate } from 'react-router-dom';



// const FixedHeader = styled('div')(({ theme }) => ({
//   position: 'fixed',
//   top: 0,
//   left: 0,
//   right: 0,
//   backgroundColor: theme.palette.background.default,
//   zIndex: 1100,
// }));




// const StyledTableCell = styled(TableCell)(({ theme }) => ({
//   width: '20%',
//   [theme.breakpoints.down('sm')]: {
//     padding: '3px',
//     fontSize: '12px',
//   },
// }));

// const StyledCustomerName = styled(Button)(({ theme }) => ({
//   fontSize: '16px',
//   padding: '6px 12px',
//   border: `1px solid ${theme.palette.primary.main}`,
//   borderRadius: '4px',
//   backgroundColor: 'transparent',
//   color: theme.palette.primary.main,
//   textTransform: 'none',
//   '&:hover': {
//     backgroundColor: theme.palette.action.hover,
//   },
//   [theme.breakpoints.down('sm')]: {
//     fontSize: '12px',
//   },
// }));

// const DateInput = styled('input')(({ theme }) => ({
//   padding: '10px',
//   marginTop: '8px',
//   border: `1px solid ${theme.palette.divider}`,
//   borderRadius: '4px',
//   '&.readonly': {
//     backgroundColor: theme.palette.action.disabledBackground,
//   },
//   [theme.breakpoints.down('sm')]: {
//     fontSize: '14px',
//   },
// }));

// const FixedTableContainer = styled(TableContainer)(({ theme }) => ({
//   maxHeight: 'calc(110vh - 300px)',
//   overflow: 'auto',
// }));

// const FixedTableHead = styled(TableHead)(({ theme }) => ({
//   position: 'sticky',
//   top: 0,
//   backgroundColor: theme.palette.background.default,
//   zIndex: 1,
//   '& th': {
//     backgroundColor: theme.palette.background.default,
//   },
// }));

// const StyledOrderIdCell = styled(StyledTableCell)(({ theme }) => ({
//   paddingLeft: '8px',
//   paddingRight: '8px',
//   fontWeight: 'bold',
//   textAlign: 'center',
//   [theme.breakpoints.down('sm')]: {
//     padding: '3px',
//     fontSize: '12px',
//   },
// }));

// export const AllotedOrders = () => {
//   const [channelId, setChannelId] = useState('web');
//   const [location, setLocation] = useState('');
//   const [areas, setAreas] = useState([]);
//   const [orders, setOrders] = useState([]);
//   const [fromDate, setFromDate] = useState(new Date());
//   const [selectedOrder, setSelectedOrder] = useState(null);
//   const [openModal, setOpenModal] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [showFullAddress, setShowFullAddress] = useState({});
//   const [branches, setBranches] = useState([]);
//   const [places, setPlaces] = useState({});
//   const [selectedPlaces, setSelectedPlaces] = useState({});
//   const [searchQuery, setSearchQuery] = useState('');
//   const [orderType, setOrderType] = useState('all'); // New state for order type filter
//   const [filteredOrders, setFilteredOrders] = useState([]); // New state for filtered orders
//   const [orderCounts, setOrderCounts] = useState({
//     deviation: 0,
//     cancellation: 0,
//     all: 0
//   });
//   const navigate = useNavigate();


//   // Add these new states
//   const [editModalOpen, setEditModalOpen] = useState(false);
//   const [selectedOrderForEdit, setSelectedOrderForEdit] = useState(null);

//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
//   const userId = localStorage.getItem('userId');
//   console.log("Retrieved userId:", userId);


//   // Add these new functions
//   const handleEditClick = (order) => {
//     setSelectedOrderForEdit(order);
//     setEditModalOpen(true);
//   };


//   const handleCancelOrder = async (orderId) => {
//     try {
//       const response = await fetch(
//         `${local_url}/api/SaleOrderList/CancelOrd/${orderId}/${userId}`,
//         {
//           method: 'POST',
//         }
//       );

//       if (response.ok) {
//         // Refresh orders after cancellation
//         const date = fromDate.toISOString().split('T')[0].replace(/-/g, '');
//         fetchOrders(date);
//       } else {
//         console.error('Failed to cancel order:', response.statusText);
//       }
//     } catch (error) {
//       console.error('Error canceling order:', error);
//     }
//   };




//   useEffect(() => {
//     const fetchAreas = async () => {
//       try {
//         const response = await fetch(`${local_url}/api/SFArea/${userId}`);
//         const data = await response.json();
//         setAreas(data);
//       } catch (error) {
//         console.error('Error fetching areas:', error);
//       }
//     };
//     console.log("------", userId);
//     fetchAreas();
//   }, []);



//   // Add this new function to fetch counts
//   const fetchOrderCounts = async (date) => {
//     try {
//       const response = await fetch(
//         `${local_url}/api/SaleOrderList/GetCounts/${userId}/${date}`
//       );
//       const data = await response.json();
//       setOrderCounts({
//         deviation: data.deviationCount || 0,
//         cancellation: data.cancellationCount || 0,
//         all: data.totalCount || 0
//       });
//     } catch (error) {
//       console.error('Error fetching order counts:', error);
//     }
//   };





//   // Modify your existing fetchOrders function to handle different types
//   const fetchOrders = async (date) => {
//     setLoading(true);
//     try {
//       let endpoint = `${local_url}/api/SaleOrderList/Get/WEB/${userId}/${date}`;

//       // Modify endpoint based on orderType
//       if (orderType === 'deviation') {
//         endpoint = `${local_url}/api/SaleOrderList/GetDeviation/${userId}/${date}`;
//       } else if (orderType === 'cancellation') {
//         endpoint = `${local_url}/api/SaleOrderList/GetCancellation/${userId}/${date}`;
//       }

//       const response = await fetch(endpoint);
//       const data = await response.json();
//       setOrders(data);
//     } catch (error) {
//       console.error('Error fetching orders:', error);
//     } finally {
//       setLoading(false);
//     }
//   };


//   // Add useEffect to fetch counts when date changes
//   useEffect(() => {
//     if (channelId === 'web' && location) {
//       const date = fromDate.toISOString().split('T')[0].replace(/-/g, '');
//       fetchOrderCounts(date);
//     }
//   }, [fromDate, channelId, location]);

//   // Modify the handleOrderTypeChange function
//   const handleOrderTypeChange = (event) => {
//     setOrderType(event.target.value);
//     const date = fromDate.toISOString().split('T')[0].replace(/-/g, '');
//     fetchOrders(date);
//   };



//   const fetchBranches = async (areaId) => {
//     setLoading(true);
//     try {
//       const response = await fetch(`${local_url}/api/StoreByArea/GetStorByArea/${areaId}/LZ`);
//       const data = await response.json();
//       setBranches(data);
//     } catch (error) {
//       console.error('Error fetching branches:', error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchPlacesForPincode = async (pincode) => {
//     try {
//       const response = await fetch(`${local_url}/api/Place/${pincode}`);
//       const data = await response.json();
//       setPlaces(prevPlaces => ({
//         ...prevPlaces,
//         [pincode]: data.places || []
//       }));
//     } catch (error) {
//       console.error('Error fetching places:', error);
//     }
//   };

//   const handleChannelChange = (event) => {
//     setChannelId(event.target.value);
//     if (event.target.value === 'app') {
//       setLocation('');
//     }
//   };

//   const handleLocationChange = (event) => {
//     setLocation(event.target.value);
//     fetchBranches(event.target.value);
//   };

//   const handleAllotChange = (orderId, allottee) => {
//     setOrders((prevOrders) =>
//       prevOrders.map((order) =>
//         order.saleOrderId === orderId ? { ...order, allottedTo: allottee } : order
//       )
//     );
//   };

//   const handlePlaceChange = (orderId, placeId) => {
//     setSelectedPlaces(prev => ({
//       ...prev,
//       [orderId]: placeId
//     }));
//   };

//   const handleDateChange = (setter) => (event) => {
//     setter(new Date(event.target.value));
//   };

//   useEffect(() => {
//     if (channelId === 'web' && location) {
//       const date = fromDate.toISOString().split('T')[0].replace(/-/g, '');
//       fetchOrders(date);
//     }
//   }, [fromDate, channelId, location]);

//   const handleCustomerClick = (order) => {
//     setSelectedOrder(order);
//     setOpenModal(true);
//   };

//   const handleCloseModal = () => {
//     setOpenModal(false);
//     setSelectedOrder(null);
//   };



//   const handleSaveEdit = async (editedData) => {
//     try {
//       const response = await fetch(
//         `${local_url}/api/SaleOrderList/UpdateOrder`,
//         {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json',
//           },
//           body: JSON.stringify({
//             ...editedData,
//             updatedBy: userId
//           })
//         }
//       );

//       if (response.ok) {
//         // Refresh orders after update
//         const date = fromDate.toISOString().split('T')[0].replace(/-/g, '');
//         fetchOrders(date);
//       }
//     } catch (error) {
//       console.error('Error updating order:', error);
//     }
//   };



//   const handleSeeMoreClick = (orderId) => {
//     setShowFullAddress((prev) => ({
//       ...prev,
//       [orderId]: !prev[orderId],
//     }));
//   };

//   const handleSave = async (orderId, allottee) => {
//     try {
//       const placeId = selectedPlaces[orderId] || '';
//       const response = await fetch(
//         `${local_url}/api/SaleOrderList/RedirectDelBranch?SaleOrderId=${orderId}&ToBranchId=${allottee}&NewPlaceId=${placeId}&CreatedUserId=${userId}`,
//         {
//           method: 'POST',
//         }
//       );

//       if (response.ok) {
//         const result = await response.json();
//         console.log('Save successful:', result);
//       } else {
//         console.error('Failed to save:', response.statusText);
//       }
//     } catch (error) {
//       console.error('Error saving order:', error);
//     }
//   };

//   return (
//     <Container maxWidth="lg" sx={{ padding: isMobile ? '3px' : '8px', paddingTop: '10px' }}>
//       <FixedHeader>
//         <Header />
//       </FixedHeader>
//       <Grid container spacing={2} sx={{ marginTop: 6 }}>
//         <Grid item xs={12} sm={6} sx={{ marginTop: 2 }}>
//           <FormControl fullWidth variant="outlined">
//             <InputLabel id="channel-label">Channel ID</InputLabel>
//             <Select
//               labelId="channel-label"
//               value={channelId}
//               onChange={handleChannelChange}
//               label="Channel ID"
//             >
//               <MenuItem value="web">Web</MenuItem>
//             </Select>
//           </FormControl>
//         </Grid>
//         {channelId === 'web' && (

//           <Grid item xs={12} sm={6} spacing={2} sx={{ marginY: 2 }}>
//             <FormControl fullWidth variant="outlined">
//               <InputLabel id="location-label">Area</InputLabel>
//               <Select
//                 labelId="location-label"
//                 value={location}
//                 onChange={handleLocationChange}
//                 label="Location"
//               >
//                 {areas.map((area) => (
//                   <MenuItem key={area.sfAreaId} value={area.sfAreaId}>
//                     {area.sfAreaName}
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl>
//           </Grid>
//         )}
//       </Grid>

//       {channelId === 'web' && location && (
//         <>
//           <Grid container spacing={2} sx={{ marginBottom: 2 }}>
//             <Grid item xs={12} sm={6}>
//               <FormControl fullWidth>
//                 <InputLabel shrink htmlFor="from-date">From Date</InputLabel>
//                 <DateInput
//                   type="date"
//                   id="from-date"
//                   value={fromDate.toISOString().split('T')[0]}
//                   onChange={handleDateChange(setFromDate)}
//                 />
//               </FormControl>
//             </Grid>
//             <Grid item xs={12} sm={6}>
//               <FormControl fullWidth>
//                 <InputLabel shrink htmlFor="to-date">To Date</InputLabel>
//                 <DateInput
//                   type="date"
//                   id="to-date"
//                   value={new Date().toISOString().split('T')[0]}
//                   readOnly
//                   className="readonly"
//                 />
//               </FormControl>
//             </Grid>

//             <Grid item xs={12}>
//               <Button
//                 variant="contained"
//                 color="primary"
//                 onClick={() => navigate('/create-order')}
//                 sx={{ mb: 2 }}
//               >
//                 Create Order
//               </Button>
//             </Grid>

//             <Grid item xs={12}>
//               <FormControl fullWidth variant="outlined">
//                 <InputLabel id="order-type-label">Order Type</InputLabel>
//                 <Select
//                   labelId="order-type-label"
//                   id="order-type-select"
//                   value={orderType}
//                   onChange={handleOrderTypeChange}
//                   label="Order Type"
//                 >
//                   <MenuItem value="all">
//                     All Orders ({orderCounts.all})
//                   </MenuItem>
//                   <MenuItem value="deviation">
//                     Request Deviation ({orderCounts.deviation})
//                   </MenuItem>
//                   <MenuItem value="cancellation">
//                     Cancellation Request ({orderCounts.cancellation})
//                   </MenuItem>
//                 </Select>
//               </FormControl>
//             </Grid>
//           </Grid>




//           <FixedTableContainer component={Paper} sx={{ marginTop: 2 }}>
//             <Table size={isMobile ? "small" : "medium"} stickyHeader>
//               <FixedTableHead>
//                 <TableRow>
//                   <StyledTableCell>Order ID</StyledTableCell>
//                   <StyledTableCell>Currently Alloted</StyledTableCell>
//                   <StyledTableCell>Allot To</StyledTableCell>
//                   <StyledTableCell>Place</StyledTableCell>
//                   <StyledTableCell>Actions</StyledTableCell>
//                   {!isMobile && <StyledTableCell>Address</StyledTableCell>}
//                 </TableRow>
//               </FixedTableHead>
//               <TableBody>
//                 {loading ? (
//                   <TableRow>
//                     <TableCell colSpan={6} align="center">
//                       <Typography>Loading orders...</Typography>
//                     </TableCell>
//                   </TableRow>
//                 ) : (
//                   orders.map((order) => {
//                     // Fetch places if not already fetched
//                     if (order.pincode && !places[order.pincode]) {
//                       fetchPlacesForPincode(order.pincode);
//                     }

//                     return (
//                       <TableRow key={order.saleOrderId}>
//                         <StyledOrderIdCell>
//                           <StyledCustomerName
//                             onClick={() => handleCustomerClick(order)}
//                             color="primary"
//                             size="small"
//                           >
//                             {order.saleOrderId}
//                           </StyledCustomerName>
//                         </StyledOrderIdCell>
//                         <StyledTableCell>
//                           <StyledOrderIdCell>
//                             {order.delBranchID}
//                           </StyledOrderIdCell>
//                         </StyledTableCell>
//                         <StyledTableCell>
//                           <FormControl variant="outlined" size="small" fullWidth sx={{ width: '100px' }}>
//                             <InputLabel id={`allot-label-${order.saleOrderId}`}>Allot to</InputLabel>
//                             <Select
//                               labelId={`allot-label-${order.saleOrderId}`}
//                               value={order.allottedTo || ''}
//                               onChange={(e) => handleAllotChange(order.saleOrderId, e.target.value)}
//                               label="Allot to"
//                             >
//                               {branches.map((branch) => (
//                                 <MenuItem key={branch.branchID} value={branch.branchID}>
//                                   {branch.branchName}
//                                 </MenuItem>
//                               ))}
//                             </Select>
//                           </FormControl>
//                         </StyledTableCell>
//                         <StyledTableCell>
//                           <FormControl variant="outlined" size="small" fullWidth sx={{ width: '120px' }}>
//                             <InputLabel id={`place-label-${order.saleOrderId}`}>Place</InputLabel>
//                             <Select
//                               labelId={`place-label-${order.saleOrderId}`}
//                               value={selectedPlaces[order.saleOrderId] || ''}
//                               onChange={(e) => handlePlaceChange(order.saleOrderId, e.target.value)}
//                               label="Place"
//                             >
//                               {places[order.pincode]?.map((place) => (
//                                 <MenuItem key={place.placeId} value={place.placeId}>
//                                   {place.placeName}
//                                 </MenuItem>
//                               ))}
//                             </Select>
//                           </FormControl>
//                         </StyledTableCell>
//                         <StyledTableCell>
//                           <Grid container spacing={1}>
//                             <Grid item>
//                               <Button
//                                 variant="outlined"
//                                 size="small"
//                                 sx={{ minWidth: '60px' }}
//                                 onClick={() => handleSave(order.saleOrderId, order.allottedTo)}
//                                 disabled={!order.allottedTo || !selectedPlaces[order.saleOrderId]}
//                               >
//                                 Save
//                               </Button>
//                             </Grid>
//                             <Grid item>
//                               <Button
//                                 variant="outlined"
//                                 size="small"
//                                 sx={{ minWidth: '60px' }}
//                                 onClick={() => handleEditClick(order)}
//                                 color="primary"
//                               >
//                                 Edit
//                               </Button>
//                             </Grid>
//                             <Grid item>
//                               <Button
//                                 variant="outlined"
//                                 size="small"
//                                 sx={{ minWidth: '60px' }}
//                                 onClick={() => handleCancelOrder(order.saleOrderId)}
//                                 color="error"
//                               >
//                                 Cancel
//                               </Button>
//                             </Grid>
//                           </Grid>
//                         </StyledTableCell>
//                         {!isMobile && (
//                           <StyledTableCell>
//                             <Typography variant="body2">
//                               {showFullAddress[order.saleOrderId]
//                                 ? order.customerAddress
//                                 : `${order.customerAddress.substring(0, 20)}...`}
//                               <Button
//                                 size="small"
//                                 onClick={() => handleSeeMoreClick(order.saleOrderId)}
//                               >
//                                 {showFullAddress[order.saleOrderId] ? 'See Less' : 'See More'}
//                               </Button>
//                             </Typography>
//                           </StyledTableCell>
//                         )}
//                       </TableRow>
//                     );
//                   })
//                 )}
//               </TableBody>
//             </Table>
//           </FixedTableContainer>

//           <Dialog open={openModal} onClose={handleCloseModal} fullWidth maxWidth="sm">
//             <DialogTitle>Order Details</DialogTitle>
//             <DialogContent>
//               {selectedOrder && (
//                 <>
//                   <Typography variant="subtitle1">Order ID: {selectedOrder.saleOrderId}</Typography>
//                   <Typography variant="subtitle1">Customer Name: {selectedOrder.customerName}</Typography>
//                   <Typography variant="subtitle1">Current Allocated: {selectedOrder.delBranchID}</Typography>
//                   <Typography variant="subtitle1">Mobile Number: {selectedOrder.mobile}</Typography>
//                   <Typography variant="subtitle1">Delivery Schedule Date: {selectedOrder.deliveryScheduleDate}</Typography>
//                   <Typography variant="subtitle1">Time Slot: {selectedOrder.timeSlotName}</Typography>
//                   <Typography variant="subtitle1">Address: {selectedOrder.customerAddress || 'N/A'}</Typography>
//                   <Typography variant="subtitle1">Pincode: {selectedOrder.pincode || 'N/A'}</Typography>
//                   <Typography variant="subtitle1">Place: {selectedOrder.placeName || 'N/A'}</Typography>
//                   <Typography variant="subtitle1">Order Date: {new Date(selectedOrder.orderDate).toLocaleString()}</Typography>
//                   <Typography variant="subtitle1">Selected Place: {
//                     places[selectedOrder.pincode]?.find(
//                       place => place.placeId === selectedPlaces[selectedOrder.saleOrderId]
//                     )?.placeName || 'Not Selected'
//                   }</Typography>
//                 </>
//               )}
//             </DialogContent>
//             <DialogActions>
//               <Button onClick={handleCloseModal} color="primary">
//                 Close
//               </Button>
//             </DialogActions>
//           </Dialog>
//         </>
//       )}

//       {/* Add this before the closing Container tag */}
//       {selectedOrderForEdit && (
//         <EditOrderForm
//           order={selectedOrderForEdit}
//           open={editModalOpen}
//           onClose={() => {
//             setEditModalOpen(false);
//             setSelectedOrderForEdit(null);
//           }}
//           onSave={handleSaveEdit}
//           branches={branches}
//           places={places}
//         />
//       )}
//     </Container>
//   );
// };

// export default AllotedOrders;








import React, { useState, useEffect } from 'react';
import {
  Container,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Grid,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { Header } from "../Header";
import { local_url } from '../Const';
import DiversionTable from './DiversionTable';
import CancellationTable from './CancellationTable';
import RescheduleTable from './Reschedule';


const FixedHeader = styled('div')(({ theme }) => ({
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  backgroundColor: theme.palette.background.default,
  zIndex: 1100,
}));

const DateInput = styled('input')(({ theme }) => ({
  padding: '10px',
  marginTop: '8px',
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: '4px',
  '&.readonly': {
    backgroundColor: theme.palette.action.disabledBackground,
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '14px',
  },
}));

export const AllotedOrders = () => {
  const [channelId, setChannelId] = useState('web');
  const [location, setLocation] = useState('');
  const [areas, setAreas] = useState([]);
  const [fromDate, setFromDate] = useState(new Date());
  const [toDate, setToDate] = useState(new Date());
  const [orderType, setOrderType] = useState('deviation');
  const [orderCounts, setOrderCounts] = useState({
    deviation: 0,
    cancellation: 0,
    reschedule: 0,
    all: 0
  });
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const userId = localStorage.getItem('userId');

  useEffect(() => {
    const fetchAreas = async () => {
      try {
        const response = await fetch(`${local_url}/api/SFArea/${userId}`);
        const data = await response.json();
        setAreas(data);
      } catch (error) {
        console.error('Error fetching areas:', error);
      }
    };
    fetchAreas();
  }, [userId]);

  const fetchOrderCounts = async () => {
    try {
      const token = localStorage.getItem('AuthorizationToken');
      if (!token) {
        console.error('Authorization token not found');
        return;
      }

      const formattedFromDate = fromDate.toISOString().split('T')[0].replace(/-/g, '');
      const formattedToDate = toDate.toISOString().split('T')[0].replace(/-/g, '');

      const response = await fetch(
        `${local_url}/api/OrderStatus/GetChangeRequestList/${location}/ALL/${formattedFromDate}/${formattedToDate}?FromBranchId=ALL`,
        {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        }
      );

      if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
      const data = await response.json();

      let diversionCount = 0;
      let cancellationCount = 0;
      let rescheduleCount = 0;


      if (Array.isArray(data)) {
        data.forEach(order => {
          if (order.requestedStatus === 'DR' && order.currentApprovalStatus !== 'DN') {
            diversionCount++;
          }
          if (order.requestedStatus === 'CR') {
            cancellationCount++;
          }
          if (order.requestedStatus === 'HR') {
            rescheduleCount++;
          }
        });
      }

      setOrderCounts({
        deviation: diversionCount,
        cancellation: cancellationCount,
        reschedule: rescheduleCount,
        all: diversionCount + cancellationCount + rescheduleCount
      });
    } catch (error) {
      console.error('Error fetching order counts:', error);
    }
  };

  useEffect(() => {
    if (channelId === 'web' && location) {
      fetchOrderCounts();
    }
  }, [channelId, location, fromDate, toDate, refreshTrigger]);

  const handleChannelChange = (event) => {
    setChannelId(event.target.value);
    if (event.target.value === 'app') setLocation('');
  };

  const handleLocationChange = (event) => {
    setLocation(event.target.value);
  };

  const handleOrderTypeChange = (event) => {
    setOrderType(event.target.value);
  };

  const handleFromDateChange = (event) => {
    setFromDate(new Date(event.target.value));
  };

  const handleToDateChange = (event) => {
    setToDate(new Date(event.target.value));
  };

  const handleActionTaken = () => {
    setRefreshTrigger(prev => prev + 1);
  };

  return (
    <Container maxWidth="lg" sx={{ padding: isMobile ? '3px' : '8px', paddingTop: '10px' }}>
      <FixedHeader>
        <Header />
      </FixedHeader>
      <Grid container spacing={2} sx={{ marginTop: 6 }}>
        <Grid item xs={12} sm={6} sx={{ marginTop: 2 }}>
          <FormControl fullWidth variant="outlined">
            <InputLabel id="channel-label">Channel ID</InputLabel>
            <Select
              labelId="channel-label"
              value={channelId}
              onChange={handleChannelChange}
              label="Channel ID"
            >
              <MenuItem value="web">Web</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        {channelId === 'web' && (
          <Grid item xs={12} sm={6} spacing={2} sx={{ marginY: 2 }}>
            <FormControl fullWidth variant="outlined">
              <InputLabel id="location-label">Area</InputLabel>
              <Select
                labelId="location-label"
                value={location}
                onChange={handleLocationChange}
                label="Location"
              >
                {areas.map((area) => (
                  <MenuItem key={area.sfAreaId} value={area.sfAreaId}>
                    {area.sfAreaName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        )}
      </Grid>

      {channelId === 'web' && location && (
        <Grid container spacing={2} sx={{ marginBottom: 2 }}>
          <Grid item xs={12} sm={4}>
            <FormControl fullWidth>
              <InputLabel shrink htmlFor="from-date">From Date</InputLabel>
              <DateInput
                type="date"
                id="from-date"
                value={fromDate.toISOString().split('T')[0]}
                onChange={handleFromDateChange}
              />
            </FormControl>
          </Grid>
          
          <Grid item xs={12} sm={4}>
            <FormControl fullWidth>
              <InputLabel shrink htmlFor="to-date">To Date</InputLabel>
              <DateInput
                type="date"
                id="to-date"
                value={toDate.toISOString().split('T')[0]}
                onChange={handleToDateChange}
              />
            </FormControl>
          </Grid>
        
          <Grid item xs={12} sm={4}>
            <FormControl fullWidth variant="outlined">
              <InputLabel id="order-type-label">Request Type</InputLabel>
              <Select
                labelId="order-type-label"
                id="order-type-select"
                value={orderType}
                onChange={handleOrderTypeChange}
                label="Order Type"
              >
                <MenuItem value="deviation"> Deviation Request  ({orderCounts.deviation})</MenuItem>
                <MenuItem value="cancellation">Cancellation Request ({orderCounts.cancellation})</MenuItem>
                <MenuItem value="reschedule">Reschedule Request ({orderCounts.reschedule})</MenuItem>

              </Select>
            </FormControl>
          </Grid>
        </Grid>
      )}

      {orderType === 'deviation' && (
        <DiversionTable
          fromDate={fromDate}
          toDate={toDate}
          channelId={channelId}
          location={location}
          userId={userId}
          onActionTaken={handleActionTaken}
        />
      )}
      {orderType === 'cancellation' && (
        <CancellationTable
          fromDate={fromDate}
          toDate={toDate}
          channelId={channelId}
          location={location}
          userId={userId}
          onActionTaken={handleActionTaken}
        />
      )}
      {orderType === 'reschedule' && (
        <RescheduleTable
          fromDate={fromDate}
          toDate={toDate}
          channelId={channelId}
          location={location}
          userId={userId}
          onActionTaken={handleActionTaken}
        />
      )}
    </Container>
  );
};

export default AllotedOrders;